import store from '@/store';
import axios from 'axios';
import util from '@/libs/util';
import Setting from '@/setting.js';
import router from '@/router'


import { Message, Notice } from 'view-design';
// import { failCode } from './fail-code.js'


// 创建一个 axios 实例
// axios.defaults.withCredentials = true;

const service = axios.create({
    baseURL: Setting.apiBaseUrl,
    timeout: 50000, // 请求超时时间
});


// 请求拦截器
service.interceptors.request.use(
    config => {
        let { token } = store.state.user.profile;
        if (token) {
            Object.assign(config.headers, {
                'Content-Type': 'application/json;charset=utf-8',
                token
            })
        }
        return config;
    },
    error => {
        // 发送失败
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    res => {
        if (res.headers.token) {
            store.commit('user/setUser', {
                token: res.headers.token
            })
        }


        // let axiosData = res.data.Response ? res.data.Response : res;
        // 文件下载，在直接返回 res


        let axiosData = res.data.code ? res.data : (res.data.Response ? res.data.Response : res);

        // 错误拦截
        if (res.data && res.data.code && res.data.code != 200) {
            Message.info({
                content: (axiosData.msg),
                duration: Setting.modalDuration,
            })

            // token过期
            if (axiosData.code == 500 && (axiosData.msg == 'token解析失败' || axiosData.msg == '会话超时，请重新登录！')) {
                // 清除token
                store.commit('user/setUser', 'clear')
                // 跳转到登录页面
                router.push('/login')
            }
            return
        }
        return axiosData
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 400: error.message = '请求错误'; break;
                case 401: error.message = '未授权，请登录'; break;
                case 403: error.message = '拒绝访问'; break;
                case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
                case 408: error.message = '请求超时'; break;
                case 500: error.message = '服务器内部错误';
                    Message.error({
                        content: '服务器内部错误，请联系管理员',
                        duration: Setting.modalDuration,
                    })
                    // 清除token
                    store.commit('user/setUser', 'clear')
                    // 跳转到登录页面
                    router.push('/login')
                    break;
                case 501: error.message = '服务未实现'; break;
                case 502: error.message = '网关错误'; break;
                case 503: error.message = '服务不可用'; break;
                case 504: error.message = '网关超时'; break;
                case 505: error.message = 'HTTP版本不受支持'; break;
                default: break;
            }
        }
        return Promise.reject(error);
    }
);

export default service;
